import React, { useState, useEffect } from "react";
import ShopService from "../../services/ShopService";

import { motion } from "motion/react";
const ListShop = () => {
  const [shop, setShop] = useState([]);
  const [currentShop, setCurrentShop] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveShop();
  }, []);

  const retrieveShop = () => {
    ShopService.getAll()
      .then((response) => {
        console.log(response);
        setShop(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  console.log("Current Shop:" + JSON.stringify(currentShop));

  return (
    <>
      <div
        id="aboutus"
        className="wrapper py-10"
      >
        {shop &&
          shop.map((shop, index) => (
            <div
              className="container grid grid-cols-1 md:grid-cols-2 gap-8 min-h-[600px]"
              key={index}
            >
              <motion.div
                initial={{ x: -150, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 0.6 },
                    ease: "easeIn",
                  },
                }}
                className="flex justify-center overflow-hidden "
              >
                <img
                  className="object-cover rounded-xl"
                  src={shop.image}
                  alt=""
                />
              </motion.div>
              <div
                className="flex flex-row text-gray-500 items-center 
       "
              >
                <div>
                  <motion.h1
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{
                      x: 0,
                      opacity: 1,
                      transition: {
                        delay: 0.5,
                        x: { type: "spring", stiffness: 60 },
                        opacity: { duration: 0.6 },
                        ease: "easeIn",
                      },
                    }}
                    className="text-4xl lg:text-6xl font-semibold mb-10"
                  >
                    {shop.name}
                  </motion.h1>
                  <motion.p
                    initial={{ x: 200, opacity: 0 }}
                    whileInView={{
                      x: 0,
                      opacity: 1,
                      transition: {
                        delay: 0.5,
                        x: { type: "spring", stiffness: 60 },
                        opacity: { duration: 0.6 },
                        ease: "easeIn",
                      },
                    }}
                    dangerouslySetInnerHTML={{ __html: shop.description }}
                  />
                </div>

                <button
                  className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-20 right-0"
                >
                  <a
                    href={"/admin/shop/" + shop.id}
                    className="lg:text-1xl"
                  >
                    Edit About us
                  </a>
                </button>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default ListShop;
